<template>
  <v-container class="mt-10 pl-8">
    <v-layout row>
      <v-flex offset-sm5>
        <img src="../assets/remindo.png" alt="" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <h4 class="mt-1">Login</h4>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <form>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newUser.email"
                  label="Email"
                  prepend-icon="mail"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newUser.password"
                  label="Password"
                  prepend-icon="lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>

          <!-- Buttons -->
          <v-layout row>
            <v-flex xs12 md6 offset-sm3>
              <v-col>
                <v-btn
                  color="success"
                  class="mx-2"
                  @click="login"
                  :disabled="!formIsValid || isProcessing"
                  id="tura"
                  >Login</v-btn
                >
              </v-col>
              <v-col>
                Don't have an account, <a href="/signup">signup</a>
              </v-col>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
      <v-snackbar v-model="loginError" color="warning" top>
        Username or password is incorrect
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loginError: false,
      isProcessing: false,
      showPassword: false,
      newUser: {
        email: null,
        password: null
      }
    };
  },
  methods: {
    login() {
      if (!this.formIsValid) {
        return;
      }
      console.log("sign inning");
      this.isProcessing = true;
      this.$createDatabase("auth", "auth", this.$dbUrl);
      this.$db.auth
        .login(this.newUser.email, this.newUser.password)
        .then(session => {
          console.log({ session });
          this.$network.defaults.headers.username = session.name;
          this.$network.defaults.headers.token = session.roles[0];
          console.log("getting user");
          return this.$network.post("/user/get", {
            username: this.newUser.email
          });
        })
        .then(result => {
          const user = result.data.user;
          console.log({ user });
          //store user
          this.$store.dispatch("saveUser", user);
          this.$register();
          this.$router.push("/agenda/upcoming");
        })
        .catch(err => {
          console.log({ err });
          this.isProcessing = false;
          this.loginError = true;
        });
    }
  },
  computed: {
    formIsValid() {
      return this.newUser.email !== null && this.newUser.password !== null;
    }
  }
};
</script>

<style scoped>
img {
  border-radius: 50%;
  width: 150px;
  margin: 12px;
}
@media screen and (max-width: 400px) {
  img {
    margin-left: 70px;
    margin-right: 70px;
  }
}
</style>
